import {
  AfterViewInit, Component, HostBinding, Input, OnDestroy, OnInit, ViewEncapsulation
} from '@angular/core';
import { Configuration } from '@shared/models/configuration';
import { Subscription, interval } from 'rxjs';

import { NavigationCancel, NavigationEnd, NavigationStart, Router, RoutesRecognized } from '@angular/router';
import { FuseConfigService } from '@barebone-fuse-services/config.service';
import { FuseSidebarService } from "@barebone-fuse/@fuse/components/sidebar/sidebar.service";
import { AnalyticsService } from '@core/services/analytics.service';
import { AuthApiService } from '@core/services/auth-api.service';
import { CommandService } from '@core/services/command.service';
import { ItpDesktopService } from '@core/services/itpdesktopservices/itp-desktop.service';
import { ParticleApiService } from '@core/services/particle-api.service';
import { ParticleCacheService } from '@core/services/particle-cache.service';
import { RightSideMagicBarStateService } from '@core/services/right-side-magic-bar/right-side-magic-bar-state.service';
import { Store, select } from '@ngrx/store';
import { PlatformCommand } from '@shared/commands/command-base';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { getSideBarComponentFoldStatus } from '@shared/components/platform-sidebar/store/platform-sidebar.selector';
import { PlatformMagicbarState } from '@shared/components/platform-tool/platform-tool-magic-bar/store/platfomr-magicbar.reducer';
import { Api } from '@shared/constants/common-field.constants';
import { MagicLinkModel } from '@shared/models/platform-tool-models';
import { getCurrentPlatformLink } from '@shared/store/reducers/particle.reduer';
import { hasFeature } from '@shared/store/selectors/security.selector';
import { Observable, Subject, zip } from 'rxjs';
import {debounceTime, filter, mergeMap, take, takeUntil, timeInterval } from 'rxjs/operators';
import { IQueryState } from '../../store/reducers/query.reducer';
import { getQueryResponse } from '../../store/selectors/query.selector';
import { GridLayoutClass } from '../platform-tool/platform-tool-magic-bar/models/magic-bar-models';
import {PlatformManagementService} from '@shared/services/platform-management.service';
import {ParticleCacheModel} from "@shared/models/particle-cache.model";
import {FuseSplashScreenService} from "@barebone-fuse-services/splash-screen.service";
import {XatBotActionService} from '@features/xatbot/services/xat-bot-action.service';
import {XatBotDataService} from '@features/xatbot/services/xat-bot-data.service';
import {xatAskFromSearch} from '@features/xatbot/models/xat-bot-ask-link';
import {magicLinkOnlyLeaves} from './magic-link-only-guard';

@Component({
    standalone: false,
    selector: 'particle-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss', '../../../assets/icons/meteocons/style.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppLayoutComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() currentProject$: any;
  onConfigChanged: Subscription;
  fuseSettings: any;
  navigation: any;
  @HostBinding('attr.fuse-layout-mode') layoutMode;
  showCollaborationSidePanel: boolean;
  showOnbording = true;
  public pullingSubscribe$: Subject<void>;
  private onBoarding: any;
  showLoadingBar: boolean;
  private demoHistory: any;
  private demoHistory$: Observable<any>;
  private unSubscribe$ = new Subject<void>();
  dataPreparationCompleted = 0;
  totalDataPreparationNeeded = 0;
  isMajorRelease: boolean;
  isDesktop: string;
  hasFeature$: Observable<(id: string) => any>;
  isMagicLinkOnly: boolean;
  accessDenied = false;
  platformLink: MagicLinkModel;
  hideHeaderBar: boolean;
  hideRightSideBar: boolean;
  hideLeftSideBar: boolean;
  isNavbarFolded = false;
  gridLayoutClass = 'two-column';
  isRightSidebarFolded = true;
  magicBarEnabled = false;

  showDownTimeMessage = false;

  constructor(private fuseConfig: FuseConfigService,
              private analyticsService: AnalyticsService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private particleService: ParticleApiService,
              private particleCacheService: ParticleCacheService,
              private router: Router,
              private itpDesktopService: ItpDesktopService,
              private sidebarService: FuseSidebarService,
              private queryStore: Store<IQueryState>,
              private authService: AuthApiService,
              private commandService: CommandService,
              private rightSidebarStore: Store<PlatformSidebarState>,
              public platformManagementService: PlatformManagementService,
              private magicbarStore: Store<PlatformMagicbarState>,
              private xatBotActionService: XatBotActionService,
              private xatBotDataService: XatBotDataService,
              private rightSideMagicBarStateService: RightSideMagicBarStateService) {

    this.pullingSubscribe$ = new Subject<void>();
    this.onBoarding = this.particleCacheService.getItem('onBoarding');
    this.showDownTimeMessage = !!Configuration.getConfig('downTimeMessageModel');
    this.hideHeaderBar = true;
    this.hideRightSideBar = false;
    this.hideLeftSideBar = !this.platformManagementService.getPlatformAppService().hasMenuItem();
    this.isMagicLinkOnly = true;
    if (this.onBoarding) {
      this.totalDataPreparationNeeded = this.onBoarding.totalDataPreparationNeeded;
      this.dataPreparationCompleted = this.onBoarding.dataPreparationCompleted;
      this.isMajorRelease = this.onBoarding && this.onBoarding.onBoardingInfo && this.onBoarding.onBoardingInfo.isMajorRelease;
    }
    this.demoHistory$ = this.queryStore.pipe(select(getQueryResponse, 'MyDemo'), takeUntil(this.unSubscribe$));
    this.demoHistory$.subscribe(state => {
      this.demoHistory = state;
      if (this.demoHistory == null) {
        if (this.onBoarding && this.onBoarding.isCompleted === false) {
          //this.handleOnBoarding();
        }
      }
    }, err => {
      console.error('Can not fetch demoHistory ', err);
      if (this.onBoarding && this.onBoarding.isCompleted === false) {
        //this.handleOnBoarding();
      }
    });

    this.navigation = [];
    this.onConfigChanged =
      this.fuseConfig.onConfigChanged
        .subscribe(
          (newSettings) => {
            this.fuseSettings = newSettings;
            this.layoutMode = this.fuseSettings.layout.mode;
          }
        );
    try {
      Configuration.getNavigation().subscribe(nav => {
        console.log('got an observable', nav);
        if (nav) {
          this.navigation = nav;
        } else {
          this.navigation = [];
        }
      });
    } catch (e) {
      this.navigation = Configuration.getNavigation();
      console.log('got an object', this.navigation);
    }
    router.events.subscribe(
      (event) => {
        if (event instanceof RoutesRecognized) {
          const url = window.location.href.toLowerCase();
          // MEET-E-49-03: the rule lives in magicLinkOnlyLeaves (EAT pages and Orbitax Meet stay).
          if (this.isMagicLinkOnly && magicLinkOnlyLeaves(url)) {
            this.navigateToTaskCompletionPage();
            return;
          }
        }
        if (event instanceof NavigationStart) {
          this.showLoadingBar = true;
        }
        if (event instanceof NavigationEnd) {
          this.showLoadingBar = false;
          this.itpDesktopService.isItpLoaded(event.url);
        }
        if (event instanceof NavigationCancel) {
          this.showLoadingBar = false;
        }
      });
    this.showCollaborationSidePanel = false;
  }


  private handleOnBoarding() {
    interval(5 * 1000)
      .pipe(timeInterval())
      .pipe(takeUntil(this.pullingSubscribe$))
      .pipe(mergeMap(() => this.particleService.getOnBoardingStatus()))
      .subscribe((response: any) => {
        console.log(response);
        this.totalDataPreparationNeeded = response.totalDataPreparationNeeded;
        this.dataPreparationCompleted = response.dataPreparationCompleted;
        if (response && response.isCompleted) {
          //this.isOnboardingComplete = true;
          this.destroyPulling();
        }
      }, error => {
        this.destroyPulling();
        console.log('Error in pulling Onbording');
      });
  }

  continueToOrbitaxButtonPressed($event) {
    console.log($event.isPressedToOrbitaxButton);
    if ($event.isPressedToOrbitaxButton) {
      if($event.navigateOnly){
        this.showOnbording = false;
        this.handleIntend();
        return;
      }
      const updateUserOnBoardingConfirmationStatusCommand = new PlatformCommand('UpdateUserOnBoardingStatusCommand', Api.Security);
      updateUserOnBoardingConfirmationStatusCommand. waitForResponse = true;
      updateUserOnBoardingConfirmationStatusCommand.fieldValues['IsNewsletterSubscriberCheckboxChecked'] = $event.isNewsletterSubscriberCheckboxChecked;
      this.commandService.executePlatformCommand(updateUserOnBoardingConfirmationStatusCommand).subscribe(response => {
        this.showOnbording = false;
        if (response) {
          Configuration.AddConfig('isSubscribedToNews', true);
          try {
            this.particleCacheService.saveItem('hasUserConfirmedOnBoarding',
              new ParticleCacheModel({type: 'hasUserConfirmedOnBoarding', value: true}));
          } catch (e) {
            console.log('Could not cache hasUserConfirmedOnBoarding: ', e);
          }
          this.handleIntend();
        }
      });
      const platformCountryStateCommand = new PlatformCommand('PlatformCountrySelectorDialogCommand', Api.Security);
      if(Configuration.getConfig('ShouldUpdateCountryLicense')){
        this.commandService.executePlatformCommand(platformCountryStateCommand).subscribe(response => {
          //
        })
      }
    }
  }


  private handleIntend() {
//debugger;
    const intention = this.particleCacheService.getItem('Intention');
    if (intention && intention['commandToExecute']) {
      const command = intention['commandToExecute'];
      this.fuseSplashScreenService.show()
      this.executeCommandToApi(command);
      this.particleCacheService.clearItem(['Intention']);
    }
  }

  executeCommandToApi(command: PlatformCommand) {
    this.fuseSplashScreenService.show()
      this.commandService.executePlatformCommand(command).pipe(takeUntil(this.unSubscribe$)).subscribe((state) => {
        if (state.fieldValues['RedirectCommand']) {
          this.executeCommandToApi(state.fieldValues['RedirectCommand']);
        } else if (state.fieldValues['RedirectUrl']) {
          this.fuseSplashScreenService.hide()
          this.router.navigateByUrl(state.fieldValues['RedirectUrl']).then();
        }
      });
  }

  ngAfterViewInit(): void {
    // Classic-shell open-guarantee (mirror of the beta shell's at
    // platform-tool-app-layout.ngAfterViewInit): after a "Switch to Classic Mode" from XatBot, a
    // thread id is stashed on the URL. Open the always-mounted legacy floating window — its inner
    // XatBotComponent runs the existing window.location xatThreadId restore + strip. OpenXatBotFloating
    // nexts a replaying BehaviorSubject the window subscribes to, so ordering is safe.
    const switchParams = this.xatBotDataService.getUrlParameters(window.location.search);
    // / and /home already mount a center XatBot. Let that instance restore the
    // thread; opening the legacy floating window first consumes the transport
    // thread id and leaves the center XatBot with nothing to restore.
    // MEET-E-11-25: an ask link (?xatAsk=) opens the same floating window, whose chat takes the request.
    if ((switchParams['xatThreadId'] || xatAskFromSearch(window.location.search)) && !this.xatBotDataService.isCenterXatBotRoute()) {
      // Open the legacy floating window only AFTER navigations settle. The classic shell restores a
      // platform-link route right after mount; if we open the floating window immediately, its inner
      // XatBotComponent mounts before that navigation, so activatedRoute.params fires twice — the
      // second (post-strip) emission clears the just-restored thread. Opening after the nav settles
      // (debounced NavigationEnd, with a fallback) yields a single emission, mirroring the 2.0 path.
      let opened = false;
      const openFloating = () => {
        if (opened) { return; }
        opened = true;
        this.xatBotActionService.OpenXatBotFloating();
      };
      this.router.events.pipe(
        filter(e => e instanceof NavigationEnd),
        debounceTime(300),
        take(1),
        takeUntil(this.unSubscribe$)
      ).subscribe(() => openFloating());
      setTimeout(openFloating, 2000);
    }
  }

  ngOnInit() {
    this.rightSidebarStore.select(getSideBarComponentFoldStatus, 'navbar').subscribe(res => {
      if (res !== undefined) {
        this.isNavbarFolded = res;
      }
    });
    this.rightSideMagicBarStateService.gridLayoutClass$.subscribe(res => {
      if (res !== undefined) {
        this.gridLayoutClass = res;
        this.isRightSidebarFolded = res === GridLayoutClass.TwoColumn;
      }
    });
    this.rightSidebarStore.select(getSideBarComponentFoldStatus, 'rightsidebar').subscribe(res => {
      if (res !== undefined) {
        this.isRightSidebarFolded = res;
      }
    });
    this.hasFeature$ = this.queryStore.pipe(select(hasFeature), takeUntil(this.unSubscribe$));
    this.hasFeature$.subscribe(feature => {
      if (feature) {
        this.isMagicLinkOnly = feature('MAGIC-LINK-ONLY') === true;
        if (this.platformLink) {
          this.hideHeaderBar = this.platformLink.fieldValues['HideHeaderBar'] || feature('HIDE-HEADER');
          //this.hideRightSideBar = this.platformLink.fieldValues['HideRightSideBar'];
        } else {
          this.hideHeaderBar = this.isMagicLinkOnly || feature('HIDE-HEADER');
          this.hideRightSideBar = this.isMagicLinkOnly || feature('HIDE-RIGHT-SIDEBAR');
          this.hideLeftSideBar = this.isMagicLinkOnly || feature('HIDE-MENU') || !this.platformManagementService.getPlatformAppService().hasMenuItem();
        }
        this.setAccessDeniedIfApplicable();
      }
    });
    const platformLinkSelector$ = this.queryStore.pipe(select(getCurrentPlatformLink), takeUntil(this.unSubscribe$));
    zip(this.hasFeature$, platformLinkSelector$).subscribe(results => {
      if (results && results.length === 2) {
         const platformLink = results[1];
         const feature = results[0];
         if (platformLink) {
          this.platformLink = platformLink;
          this.hideHeaderBar = (this.platformLink && this.platformLink.fieldValues['HideHeaderBar']) || feature('HIDE-HEADER');
          this.hideRightSideBar = (this.platformLink && this.platformLink.fieldValues['HideRightSideBar']) || feature('HIDE-RIGHT-SIDEBAR');
          this.hideLeftSideBar = (this.platformLink && this.platformLink.fieldValues['HideLeftSideBar']) || feature('HIDE-MENU') || !this.platformManagementService.getPlatformAppService().hasMenuItem();
        } else {
          this.hideHeaderBar = this.isMagicLinkOnly || feature('HIDE-HEADER');
          this.hideRightSideBar = feature('HIDE-RIGHT-SIDEBAR');
          this.hideLeftSideBar = this.isMagicLinkOnly || feature('HIDE-MENU') || !this.platformManagementService.getPlatformAppService().hasMenuItem();
        }
        if (this.hideRightSideBar) {
          this.rightSideMagicBarStateService.setGridLayoutClass(GridLayoutClass.TwoColumn);
        }
      }
      this.setAccessDeniedIfApplicable();
    });
  }

  private setAccessDeniedIfApplicable() {
    if (this.isMagicLinkOnly && magicLinkOnlyLeaves(window.location.href)) {
      this.navigateToTaskCompletionPage();
    }
  }

  private navigateToTaskCompletionPage() {
    const taskCompletionPlatformCommand = new PlatformCommand('StackHolderTaskCompletionLinkCommand', 'FlowApi');
    this.commandService.executePlatformCommand(taskCompletionPlatformCommand).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
      if (response.fieldValues['RedirectUrl']) {
        this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
      }
    });
  }

  ngOnDestroy() {
    this.onConfigChanged.unsubscribe();
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
    this.destroyPulling();
  }

  destroyPulling() {
    if (this.pullingSubscribe$) {
      this.pullingSubscribe$.next();
      this.pullingSubscribe$.complete();
    }
  }

  continueToDowntime(event: any) {
    this.showDownTimeMessage = false;
  }
}
